export const headCells = [
  {
    id: "image",
    numeric: false,
    disablePadding: false,
    label: "Image",
  },
  {
    id: "title",
    numeric: false,
    disablePadding: false,
    label: "Title",
  },
  {
    id: "Name",
    numeric: false,
    disablePadding: false,
    label: "Name",
  },
  {
    id: "content",
    numeric: false,
    disablePadding: false,
    label: "content",
  },

  {
    id: "date",
    numeric: false,
    disablePadding: false,
    label: "Date",
  },

  {
    id: "action",
    disablePadding: false,
    label: "Action",
  },
];
